import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Timestamp from 'react-timestamp';
import Grid from '@material-ui/core/Grid';
import FeedbackBadIcon from '../Icon/FeedbackBadIcon';
import FeedbackNeutralIcon from '../Icon/FeedbackNeutralIcon';
import FeedbackGoodIcon from '../Icon/FeedbackGoodIcon';
import KobooButton from '../Layout/KobooButton';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useMediaQuery, useTheme } from '@material-ui/core';
import ChatIcon from '@material-ui/icons/Chat';

export const useStyles = makeStyles(() => (
  {
    icon: {
      width: '30px',
      height: '30px',
      margin: '-10px',
    },
    button: {
      padding: '3px 20px !important',
      width: 'auto !important',
    },
    smallButton: {
      width: '41px !important',
      minWidth: '40px',
      padding: '8px 8px !important'
    },
  }
));
export const UserRentRow = props => {

  const {
    rent,
    showFeedback,
  } = props;

  const classes = useStyles();
  const theme = useTheme();
  const matchesXl = useMediaQuery(theme.breakpoints.up('xl'));
  const matchesLg = useMediaQuery(theme.breakpoints.up('lg'));
  return (

    <TableRow
      key={rent.id}
      hover
      tabIndex={-1}
    >
      <TableCell>
        <Timestamp
          format="full"
          twentyFourHour
          time={rent.start_date}
        />
      </TableCell>
      <TableCell>
        {rent.end_date
          ?
          <Timestamp
            format="full"
            twentyFourHour
            time={rent.end_date}
          />
          :
          ''}
      </TableCell>
      <TableCell>
        {rent.start_site.renter_info_name}
      </TableCell>
      <TableCell>
        {rent.start_site.name}
      </TableCell>
      <TableCell numeric>
        {(
          rent.rent_price !== null && rent.rent_price !== undefined
        )
          ?
          `${rent.rent_price / 100} €`
          : null}
      </TableCell>
      <TableCell>
        {rent.state || ''}
      </TableCell>
      <TableCell>
        <Grid
          container
          justifyContent={'flex-start'}
          direction={'row'}
          spacing={2}
          alignItems={'center'}
          wrap={'nowrap'}
        >
          <Grid item style={{
            paddingBottom: 0,
            paddingTop: (rent.user_feedback !== null && rent.user_feedback !== '') ? 0 : '5px',
          }}>
            {rent.user_feedback_opinion === 'bad'
            && <FeedbackBadIcon className={classes.icon} />}
            {rent.user_feedback_opinion === 'neutral'
            && <FeedbackNeutralIcon className={classes.icon} />}
            {rent.user_feedback_opinion === 'good'
            && <FeedbackGoodIcon className={classes.icon} />}
          </Grid>
          <Grid item style={{ paddingBottom: 0, paddingTop: 0 }}>
            {rent.user_feedback !== null && rent.user_feedback !== ''
            && <KobooButton
              className={matchesLg ? classes.button : classes.smallButton}
              onClick={() => showFeedback(rent.user_feedback, rent.user_feedback_opinion)}
            >
              {matchesXl && <Typography variant={'button'} noWrap>Lire l'avis</Typography>}
              {matchesLg && !matchesXl && <Typography variant={'button'} noWrap>Avis</Typography>}
              {!matchesLg && <ChatIcon/>}
            </KobooButton>}
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default UserRentRow;



// WEBPACK FOOTER //
// ./src/components/Users/UserRentRow.jsx